<template>
  <div class="w-full flex flex-col gap-2">
    <label
      class="text-white"
      :class="{
        'text-base': !compact,
        'text-sm': compact,
      }"
    >
      {{ label }}
    </label>
    <div
      class="flex flex-col w-full border border-block-2 bg-input rounded-md"
    >
      <div class="relative w-full px-2 py-3">
        <input
          type="number"
          class="block w-full pl-2 pr-12 text-white outline-none bg-transparent"
          :class="{
            'text-lg': !compact,
            'text-sm': compact,
          }"
          :placeholder="placeholder"
          v-model="valueMutable"
        />
        <img
          class="absolute inset-y-1.5 right-3 h-8 w-auto top-0 bottom-0 my-auto rounded-full"
          :src="icon"
          alt=""
        />
      </div>
      <div
        v-if="showBalance"
        class="p-3 border-t border-block-2 flex items-center justify-between"
      >
        <p class="text-white text-xs">
          {{ balanceTitle }}: {{ balanceFormatted }}
        </p>
        <button
          class="text-xs text-violet-1"
          @click="valueMutable = max"
        >
          enter max amount
        </button>
      </div>
      <!-- <div v-if="showSlider" class="py-3 border-t border-block-2">
        <Slider
          class="w-full input-slider px-3"
          :min="minPercent"
          :max="maxPercent"
          :tooltips="false"
          v-model="percentage"
        />
      </div> -->
    </div>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
// import Slider from "@vueform/slider";
import { formatDynamicDecimals } from "../../factories/Utils";

export default {
  name: "Input",
  components: {
    // Slider
  },
  props: {
    modelValue: { type: [String, Number] },
    label: { type: String },
    showBalance: { type: Boolean, default: false },
    placeholder: { type: String },
    icon: { type: String, default: "/img/eth.png" },
    balance: { type: [Number, String] },
    balanceTitle: { type: String, default: "Balance" },
    min: { type: [Number, String], default: 0 },
    max: { type: [Number, String], default: 200 },
    compact: { type: Boolean, default: false },
    // minPercent: { type: [Number, String], default: 0 },
    // maxPercent: { type: [Number, String], default: 100 },
    // showSlider: { type: Boolean, default: true },
  },

  emits: ["update:modelValue"],
  watch: {
    // percentage: {
    //   handler(val) {
    //     this.valueMutable = new BigNumber(val)
    //       .div(this.maxPercent)
    //       .times(this.max)
    //       .toNumber();
    //   },
    //   immediate: true,
    // },
    // valueMutable: {
    //   handler(val) {
    //     this.percentage = !val
    //       ? 0
    //       : new BigNumber(val).div(this.max).times(100).toNumber() ||
    //         0;
    //   },
    //   immediate: true,
    // },
  },
  computed: {
    valueMutable: {
      get() {
        return new BigNumber(this.modelValue).toFixed();
      },
      set(val) {
        this.$emit("update:modelValue", new BigNumber(val).toFixed());
      },
    },

    balanceFormatted() {
      return formatDynamicDecimals(this.balance);
    },
  },

  data() {
    return {
      percentage: 0,
    };
  },
};
</script>

<style lang="sass">
.input-slider
  --slider-bg: #111111
  --slider-connect-bg: #0B87CA
  --slider-radius: 10px
</style>
